import OurCommitment from './OurCommitment';

export default OurCommitment;
